/* eslint-disable no-undef */

/*
Product interest categories:
AutomatedPlasmaCuttingSystems,
HandheldPlasmaCuttingSystems, 
PlasmaConsumables, 
LaserConsumables, 
WaterjetSystemsAndConsumables, 
CADCAMSoftware
*/

import { isNullOrUndefined, getUrlVars } from "/Assets/js/utilities.js";
import { emeaCountries } from "./where-to-buy-country-config.js";
import { Bouncer } from "/Assets/libs/bouncer-es6.js";
import * as tomSelect from "/Assets/libs/TomSelect/tom-select.complete.js";

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".wtb-search") || document.getElementById("wtbModal")) {
        const whereToBuy = new WhereToBuy();
        window.whereToBuy = whereToBuy;
        whereToBuy.init();
    }
});

class WhereToBuy {
    constructor() { }

    init() {
        const self = this;
        this.isSearchPage = isNullOrUndefined(document.querySelector(".wtb-search")) ? false : true;
        this.wtbModal = isNullOrUndefined(document.getElementById("wtbModal")) ? false : true;

        const selects = document.querySelectorAll("[data-custom-select]");
        selects.forEach(select => {
            const selectName = select.name;
            new tomSelect(select, {
                maxItems: 1,
                maxOptions: null,
                onChange: function (value) {
                    if (selectName === "productcategory") {
                        self.pcSelectOnChange(value);
                    } else if (selectName === "country") {
                        self.countrySelectOnChange(value);
                    }
                }
            });
        });

        this.bindEvents();
        this.setupFormValidation();
    }

    pcSelectOnChange(value) {
        const self = this;
        self.resetProductInterestContent();
        self.resetCountry();

        if (value === "CADCAMSoftware" || value === "WaterjetSystemsAndConsumables") {
            self.showproductInterestContent(value);
        } else {
            self.showCountry();
        }
    }

    countrySelectOnChange(value) {
        this.resetProductInterestContent();
        var productCategoryValue = document.querySelector("select[name='productcategory']").value;
        this.showproductInterestContent(productCategoryValue, value);
    }

    bindEvents() {
        const self = this;
        self.setCategory();
    }

    setCategory() {
        var category = this.getCategoryFromUrl();
        if (!category) return;

        const pcSelect = document.querySelector("select[name='productcategory']");
        pcSelect.value = category;

        if (category === "CADCAMSoftware" || category === "WaterjetSystemsAndConsumables") {
            this.showproductInterestContent(category);
        } else {
            this.showCountry();
        }
    }

    getCategoryFromUrl() {
        var category = getUrlVars().category ? getUrlVars().category : getUrlVars().Category;
        category = !category ? getUrlVars().productcategory : category;
        return category;
    }

    resetCountry() {
        const dataProductInterestCountry = document.querySelector("[data-product-interest-country]");
        dataProductInterestCountry.classList.add("hidden");

        const countrySelect = document.querySelector("select[name='country']");
        countrySelect.value = "";
        const tomselect = countrySelect.tomselect;
        if (tomselect) {
            tomselect.clear();
        }
        var location = document.querySelector("input[name='location']");
        location.value = "";
    }

    showCountry() {
        const dataProductInterestCountry = document.querySelector("[data-product-interest-country]");
        dataProductInterestCountry.classList.remove("hidden");
    }

    resetProductInterestContent() {
        const dataProductInterest = document.querySelectorAll("[data-product-interest]");
        dataProductInterest.forEach(element => {
            element.classList.add("hidden");
        });
    }

    isEMEACountry(country) {
        return emeaCountries.includes(country);
    }

    showproductInterestContent(productInterest, country) {
        var isEmeaCountry = this.isEMEACountry(country);

        var newProductInterest =
            isEmeaCountry || productInterest != "AutomatedPlasmaCuttingSystems"
                ? productInterest
                : "ContactUsForm";

        if (country === "cn") {
            newProductInterest =
                productInterest === "WaterjetSystemsAndConsumables" ||
                    productInterest === "CADCAMSoftware"
                    ? productInterest
                    : "ContactUsForm";
        }

        const dataProductInterestCountry = document.querySelector("[data-product-interest-country]");
        const locationCntnr = document.querySelector("[data-product-interest-location]");
        const locationInput = locationCntnr.querySelector("input");
        const consumableMessageCntnr = document.querySelector("[data-product-interest-consumable-message]");
        const searchCntnr = document.querySelector("[data-product-interest-form]");
        const waterjetCntnr = document.querySelector("[data-product-interest-waterjet]");
        const softwareCntnr = document.querySelector("[data-product-interest-software]");
        const automatedFormCntnr = document.querySelector("[data-product-interest-automated]");

        switch (newProductInterest) {
            case "AutomatedPlasmaCuttingSystems":
                locationCntnr.classList.add("hidden");
                consumableMessageCntnr.classList.add("hidden");
                dataProductInterestCountry.classList.remove("hidden");
                searchCntnr.classList.remove("hidden");
                locationInput.removeAttribute("required");
                break;
            case "HandheldPlasmaCuttingSystems":
                consumableMessageCntnr.classList.add("hidden");
                dataProductInterestCountry.classList.remove("hidden");
                locationCntnr.classList.remove("hidden");
                searchCntnr.classList.remove("hidden");
                locationInput.setAttribute("required", "required");
                break;
            case "PlasmaConsumables":
            case "LaserConsumables":
                locationCntnr.classList.remove("hidden");
                consumableMessageCntnr.classList.remove("hidden");
                searchCntnr.classList.remove("hidden");
                locationInput.setAttribute("required", "required");
                break;
            case "CADCAMSoftware":
                softwareCntnr.classList.remove("hidden");
                break;
            case "WaterjetSystemsAndConsumables":
                waterjetCntnr.classList.remove("hidden");
                break;
            case "ContactUsForm":
                automatedFormCntnr.classList.remove("hidden");

                var button = automatedFormCntnr.querySelector(".btn-primary");
                var href = button.getAttribute("href");
                var regex = /AutomatedPlasmaCuttingSystems|HandheldPlasmaCuttingSystems|PlasmaConsumables|LaserConsumables|WaterjetSystemsAndConsumables|CADCAMSoftware/gi;

                if (regex.test(href)) {
                    button.setAttribute("href", href.replace(regex, productInterest));
                }
                break;
            default:
                break;
        }
    }

    setupFormValidation() {
        const self = this;
        let bouncer = new Bouncer("[data-validate]", {
            messages: {
                missingValue: {
                    checkbox: window.jsl10n.JsResources.Translations.Common.ThisFieldRequired,
                    radio: window.jsl10n.JsResources.Translations.Common.ThisFieldRequired,
                    select: window.jsl10n.JsResources.Translations.Common.ThisFieldRequired,
                    "select-multiple": window.jsl10n.JsResources.Translations.Common.ThisFieldRequired,
                    default: window.jsl10n.JsResources.Translations.Common.ThisFieldRequired
                },
                patternMismatch: {
                    email: window.jsl10n.JsResources.Translations.Common.EnterValidEmailAddress,
                    number: window.jsl10n.JsResources.Translations.Common.EnterValidNumber,
                    default: window.jsl10n.JsResources.Translations.Common.ThisFieldRequired
                }
            }
        });
        self.bouncer = bouncer;
    }
}